import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'commabreak'
})
export class CommabreakPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';
    return value.replace(/,/g, '<br>');
  }

}
